<template>
  <div>
    <div class="page-box">
      <el-table
        :data="tableData"
        v-loading="loading"
        style="width: 100%">
        <el-table-column
          fixed
          prop="createTime"
          label="消费日期"
          width="180">
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="订单号"
          width="180">
          <div class="link"
               slot-scope="{row}"
               @click="$router.push({path: `/member/orderDetail/${row.orderNo}`})">
            {{ row.orderNo }}
          </div>
        </el-table-column>
        <el-table-column
          prop="type"
          label="支付方式"
          :formatter="handleChargeMode"
          width="80">
        </el-table-column>
        <el-table-column
          prop="chargeSource"
          label="金额/次数"
          width="250">
          <div slot-scope="{row}">
            {{ row.type==='1'?row.chargeContent+'*':'' }}{{row.amount}}
          </div>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {member, dict} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE} from '../../constants'
export default {
  name: 'LogServe',
  props: {
    memberId: String
  },
  mounted () {
    this.getTableData()
    this.getChargeMode()
  },
  data () {
    return {
      loading: false,
      page: {
        pageSize: 10,
        pageNum: 1
      },
      chargeModeOption: [],
      tableData: []
    }
  },
  methods: {
    async getTableData () {
      this.loading = true
      let {data, page} = await member.pageMemberConsume({
        page: this.page,
        param: {
          orgCode: getSession(ORG_CODE),
          memberId: this.memberId
        }
      })
      this.page = page
      this.loading = false
      this.tableData = data
    },
    async getChargeMode () {
      let {data} = await dict.getDictList({
        dictTypeCode: 'CHARGE_MODE'
      })
      this.chargeModeOption = data
      this.chargeModeOption.splice(0, 0, {dictItemCode: '0', dictItemName: '会员扣费'})
      this.chargeModeOption.splice(0, 0, {dictItemCode: '1', dictItemName: '会员扣次'})
      console.log(this.chargeModeOption)
    },
    handleChargeMode (row) {
      let result = this.chargeModeOption.find(item => item.dictItemCode === row.type)
      return result ? result.dictItemName : ''
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNum = arg
      this.getData()
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
